import { FETCH_SEARCH_DATA, UPDATE_PUBLIC_FILTERS, TOGGLE_SEARCH_FILTERS_SHOW, CREATE_QUERY, SAVE_SEARCH_DATA_PARAMS } from "../actions/searchDataAction";

import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { toast } from "react-toastify";

const searchDataReducer = (
    state = {
        searchData: [],
        searchDataFetching: false,
        searchDataFetched: false,
        total: 0,
        noOfPostsFetched: 0,
        searchDataType: "",
        showSearchFilters: false,
        custom_query: "",
    },
    action,
) => {
    switch (action.type) {
        case UPDATE_PUBLIC_FILTERS:
            return { ...state, search_filters: action.payload, searchDataType: action.searchDataType };

        case SAVE_SEARCH_DATA_PARAMS:
            return { ...state, searchDataType: action.searchDataType, custom_query: action.custom_query };

        case isPending(FETCH_SEARCH_DATA):
            state = {
                ...state,
                searchDataFetching: true,
                searchData: [],
            };
            break;
        case isRejected(FETCH_SEARCH_DATA):
            state = {
                ...state,
                searchDataFetching: false,
            };
            break;
        case isFulfilled(FETCH_SEARCH_DATA):
            state = {
                ...state,
                searchDataFetching: false,
                searchDataFetched: true,
                searchData: action.payload.hits.hits,
                total: action.payload.hits.total,
                max_total: action.payload.hits.total,
                offset: action.offset,
                hasMore: action.payload.hits.hits.length < action.payload.hits.total,
                noOfPostsFetched: action.payload.hits.hits.length,
            };
            break;
        case isFulfilled(CREATE_QUERY):
            toast.success("Query created Successfully!");
            break;
        case TOGGLE_SEARCH_FILTERS_SHOW: {
            let newShow = action.payload !== undefined ? action.payload : !state.showSearchFilters;
            return { ...state, showSearchFilters: newShow };
        }
        default:
            return state;
    }
    return state;
};

export default searchDataReducer;
